export default __webpack_public_path__ + "static/media/newyear9.e043ce67.png";